import { useStore } from 'models/stores';
import FullPageMessage from './FullPageMessage';

function NoAvailableJobs() {
  const { uiStore } = useStore();
  return (
    <FullPageMessage
      icon="✌️"
      iconLabel="victory"
      main={uiStore.t('job_list_no_openings_main')}
      sub={uiStore.t('job_list_no_openings_sub')}
    />
  );
}

export default NoAvailableJobs;
